<template>
    <div>
        <b-row>
            <b-col md="6" lg="6">
                <b-card no-body bg-variant="default">
                    <div class="card-header">
                        <h5>{{ $t('Component(OtherReplyInformation):information-to-customer') }}</h5>
                    </div>
                    <div class="card-body">
                        <b-form-textarea
                            :placeholder="$t('Component(Placeholder):type-here')"
                            v-model="customerInformation"
                            @input="emit"
                        />
                    </div>
                </b-card>
            </b-col>
            <b-col md="6" lg="6">
                <b-card no-body bg-variant="default">
                    <div class="card-header">
                        <h5>{{ $t('Component(OtherReplyInformation):internal-comment') }}</h5>
                    </div>
                    <div class="card-body">
                        <b-form-textarea
                            v-model="internalComment"
                            :placeholder="$t('Component(Placeholder):type-here')"
                            @input="emit"
                        />
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row :class="declarationValidityClass">
            <b-col>
                <b-card no-body bg-variant="default">
                    <div class="card-header">
                        <h5>{{ $t('Component(OtherReplyInformation):declaration-validity') }}</h5>
                    </div>
                    <div class="card-body">
                        <DeclarationValidity
                            ref="DeclarationValidity"
                            @change="setValidity"
                            :value="null"
                            no-header
                        />
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {BCard, BRow, BCol, BFormTextarea} from 'bootstrap-vue'
import DeclarationValidity from "@/views/request/received/components/DeclarationValidity";

export default {
    components: {
        BRow, BCol, BCard, BFormTextarea, DeclarationValidity,
    },
    props: {
        request: {
            required: true
        },
        declarationValidityClass: {
            default: 'mt-2'
        }
    },
    data() {
        return {
            internalComment: null,
            customerInformation: null,
            declarationValidity: null
        };
    },
    methods: {
        setValidity(validity) {
            this.declarationValidity = validity;
            this.emit();
            this.emitValidity();
        },
        emit() {
            this.$emit('input', {
                internalComment: this.internalComment,
                customerInformation: this.customerInformation,
                declarationValidity: this.declarationValidity
            });
        },
        emitValidity() {
            this.$emit('validityChange', this.declarationValidity !== null);
        }
    },

    watch: {
        request() {
            if (this.request.otherInformation) {
                this.internalComment = this.request.otherInformation.internalComment;
                this.customerInformation = this.request.otherInformation.customerInformation;
                this.declarationValidity = this.request.otherInformation.declarationValidity;

                if (this.declarationValidity) {
                    this.$refs.DeclarationValidity.setValueByMonth(this.declarationValidity);
                    this.emitValidity();
                } else {
                    this.$refs.DeclarationValidity.setDefault();
                }
            } else {
                this.$refs.DeclarationValidity.setDefault();
            }
        }
    }
}
</script>
